module.exports = __webpack_public_path__ + "img/icon_map_199_off_110.94b62c0f.png";